import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-ordem-producao-outros-estab-edit',
  templateUrl: './ordem-producao-outros-estab-edit.component.html',
  styleUrls: ['./ordem-producao-outros-estab-edit.component.css'],
  standalone: false
})
export class OrdemProducaoOutrosEstabEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/ordens-producao-outros-estab`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Ordem de Produção Outros Estab.', link: '/ordem-producao-outros-estab' }, { label: 'Edição Ordem de Produção Outros Estab.' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'ordem-producao-outros-estab',
  };

  fields: PoPageDynamicEditField[] = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('ordem-producao-outros-estab').subscribe((data) => {
        this.fields = data;
    });
  }
}
